import { MovementCarrierPay } from "../../../powerbroker/src/MovementCarrierPay";
import { SuggestedPricing } from "../SuggestedPricing";
import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Location, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderRates extends Layout {
    buttonAvailableCredit: Button;
    buttonCreateTax: Button;
    buttonEditMaxTotal: Button;
    buttonEditTargetTotal: Button;
    buttonEstimateFuelSurcharge: Button;
    buttonExpandCharges: Button;
    buttonExpandDetails: Button;
    buttonExpandTaxes: Button;
    buttonRate: Button;
    checkboxLockMiles: Checkbox;
    chevronSpacer2: HorizontalSpacer;
    chevronSpacer3: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    labelAdditionalCharges: Label;
    labelAutoRated: Label;
    labelAvailableCredit: Label;
    labelFreightCharge: Label;
    labelRatingDetails: Label;
    labelTaxCharge: Label;
    labelTaxesHeader: Label;
    labelTotalCharge: Label;
    layoutMovementRates: MovementCarrierPay;
    layoutSuggestedPricing: SuggestedPricing;
    panelAllocation: Panel;
    panelAvailCredit: Panel;
    panelChevron2: Panel;
    panelChevron3: Panel;
    panelChevron: Panel;
    panelExciseTaxTotal: Panel;
    panelFreightCharge: Panel;
    panelOrderCarrierPay: Panel;
    panelOrderMaxPay: Panel;
    panelOrderRates: Panel;
    panelOrderTargetPay: Panel;
    panelOtherChargeTable: Panel;
    panelOtherCharges: Panel;
    panelOtherChargesHeader2: Panel;
    panelOtherChargesHeader: Panel;
    panelRateTotals: Panel;
    panelRatesHeader: Panel;
    panelRatingDetails: Panel;
    panelRatingDetailsHeader2: Panel;
    panelRatingDetailsHeader: Panel;
    panelRatingDetailsTable: Panel;
    panelReviewAdditionalCharges: Panel;
    panelReviewFreightCharge: Panel;
    panelReviewTotalCharges: Panel;
    panelSwitchSpacer: Panel;
    panelTaxTable: Panel;
    panelTaxes: Panel;
    panelTaxesContent: Panel;
    panelTaxesHeader: Panel;
    panelTaxesHeaderTitle: Panel;
    panelTotalWithTaxes: Panel;
    sourceCustomer: DataSource;
    sourceDistanceAlert: DataSource;
    sourceExcisetaxCharge: DataSource;
    sourceOrderOtherCharge: DataSource;
    sourceOrders: DataSource;
    sourceRatingDetails: DataSource;
    sourceRatingDetailsSummary: DataSource;
    spacerRatingDetailsHeader: HorizontalSpacer;
    switchByFreightItem: Switch;
    switchExciseDisableUpdate: Switch;
    switchTaxableOrder: Switch;
    tabSuggestedPricing: Tab;
    tableOtherCharges: Table;
    tableRevPerFgi: Table;
    tableRevSummary: Table;
    tableTax: Table;
    tabsetSuggestedPricing: Tabset;
    textboxBillDistance: Textbox;
    textboxCollectionMethod: Textbox;
    textboxCtrlParty: Location;
    textboxCurrencyType: Textbox;
    textboxExcisetaxTotal: Textbox;
    textboxFreightCharge2: Textbox;
    textboxFreightCharge: Textbox;
    textboxMaxMargin: Textbox;
    textboxMaxMarginPercent: Textbox;
    textboxMaxPay: Textbox;
    textboxOtherchargetotal: Textbox;
    textboxPieces: Textbox;
    textboxRate: Textbox;
    textboxRateMinWeight: Textbox;
    textboxRateType: Textbox;
    textboxRateUnitDesc: Textbox;
    textboxRateUnits: Textbox;
    textboxSegAllocCode: Textbox;
    textboxTargetMarginAmount: Textbox;
    textboxTargetMarginPercent: Textbox;
    textboxTargetPay: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalWithTax: Textbox;
    textboxWeight: Textbox;
}
